//LGEHR-63 , LGESR-67 , LGEBG-68 , LGEHU-196
var script=document.createElement("script");script.onload=function(){VIECHATBOT.start({lang:"hu"})},script.src="https://client.epromoter.hu/chatbot.js",document.head.appendChild(script);
//LGEHR-63 , LGESR-67 , LGEBG-68 , LGEHU-196